export default __webpack_public_path__ + "static/media/check-speed.cd9bf072.svg";